'use client';

import React, { useState, useEffect } from 'react';
import CardReviewCompact from './CardReviewCompact';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';
import { RiDoubleQuotesL } from 'react-icons/ri';

export default function ReviewsSliderSidebar({ reviews = [] }) {
    // Filter to only show reviews with images
    const reviewsWithImages = reviews.filter((review) => review?.images && review.images.length > 0);

    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (reviewsWithImages.length <= 1) return;

        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % reviewsWithImages.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [reviewsWithImages.length]);

    if (!reviewsWithImages || reviewsWithImages.length === 0) return null;

    const goToPrevious = () => {
        setCurrentIndex((prev) => (prev - 1 + reviewsWithImages.length) % reviewsWithImages.length);
    };

    const goToNext = () => {
        setCurrentIndex((prev) => (prev + 1) % reviewsWithImages.length);
    };

    return (
        <div className="relative overflow-hidden p-5 rounded-2xl bg-gradient-to-br from-green-50 via-white to-blue-50 border border-green-100 shadow-lg md:p-6">
            <div className="hidden absolute -top-4 -left-4 opacity-10 lg:block">
                <RiDoubleQuotesL className="text-main-color size-16" />
            </div>

            <div className="relative z-10 flex items-center justify-between mb-4">
                <div>
                    <div className="inline-flex gap-2 items-center px-3 py-1.5 mb-2 bg-white rounded-full border border-green-200 shadow-sm">
                        <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                        <span className="text-xs font-semibold text-green-700 uppercase tracking-wide">Reviews</span>
                    </div>
                    <div className="text-lg font-bold text-gray-900">What Our Travelers Say</div>
                </div>
                {reviewsWithImages.length > 1 && (
                    <div className="flex gap-1">
                        <button onClick={goToPrevious} className="p-2 rounded-full bg-white/80 border border-green-200 hover:bg-green-50 transition-colors shadow-sm">
                            <FaChevronLeft className="w-3 h-3 text-green-700" />
                        </button>
                        <button onClick={goToNext} className="p-2 rounded-full bg-white/80 border border-green-200 hover:bg-green-50 transition-colors shadow-sm">
                            <FaChevronRight className="w-3 h-3 text-green-700" />
                        </button>
                    </div>
                )}
            </div>

            <div className="relative overflow-hidden">
                <div className="flex transition-transform duration-500 ease-in-out" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
                    {reviewsWithImages.map((review, index) => (
                        <div key={review.id || index} className="w-full flex-shrink-0">
                            <CardReviewCompact review={review} />
                        </div>
                    ))}
                </div>
            </div>

            {reviewsWithImages.length > 1 && (
                <div className="flex justify-center gap-2 mt-4">
                    {reviewsWithImages.map((_, index) => (
                        <button
                            key={index}
                            onClick={() => setCurrentIndex(index)}
                            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                                index === currentIndex ? 'bg-gradient-to-r from-green-400 to-green-600 w-6' : 'bg-gray-300 hover:bg-gray-400'
                            }`}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}
